import React from 'react'
import { string, func, node, bool } from 'prop-types'
import {
  Button,
  Grid,
  Box,
  Footnote,
  Link,
  Form
} from '@cobalt/cobalt-react-components'
import { CANCEL, SETUP_MFA_GENERIC_ERROR } from '../../constants/ui.labels'
import mapError from '../../utils/mapError/mfa'
import { ContentHeader, Error, ActionButton } from '../../components'
import '../../../assets/security-key-box.css'

class SetupMFAStep extends React.Component {
  state = {
    showError: true
  }

  retry = () => {
    this.setState({
      showError: false
    })
    setTimeout(this.props.onStartRegistration, 500)
  }

  componentDidUpdate = previousProps => {
    if (this.props.errorCode !== previousProps.errorCode) {
      this.setState({
        showError: !!this.props.errorCode
      })
    }
  }

  getErrorMessage = () => {
    if (!this.state.showError || !this.props.errorCode) {
      return
    }

    return mapError(this.props.errorCode, SETUP_MFA_GENERIC_ERROR)
  }

  render() {
    const {
      title,
      subtitle,
      footnoteLabel,
      footnoteUrl,
      boxContent,
      onCancel,
      isProcessing,
      buttonAction,
      buttonDisabled,
      buttonLabel
    } = this.props

    const errorMessage = this.getErrorMessage()

    return (
      <Grid noPadding>
        <Grid.Group verticalGutters={Grid.Group.VERTICAL_GUTTERS}>
          <Grid.Column all="100" medium="100" small="100">
            <ContentHeader title={title} message={subtitle} />
            <Error message={errorMessage} />
            <div className="security-key">
              <Box>
                <Box.Content>
                  <Grid noPadding>
                    <div className="security-key-box">
                      <Grid.Group fullHeight>
                        <Grid.Column pushCenter>{boxContent}</Grid.Column>
                      </Grid.Group>
                    </div>
                  </Grid>
                </Box.Content>
              </Box>
            </div>
            <Footnote halfTopSpace>
              <Link target="_blank" href={footnoteUrl}>
                {footnoteLabel}
              </Link>
            </Footnote>
          </Grid.Column>
        </Grid.Group>
        <Form>
          {this.props.children ? (
            <Grid.Group verticalGutters={Grid.Group.VERTICAL_GUTTERS}>
              <Grid.Column>{this.props.children}</Grid.Column>
            </Grid.Group>
          ) : null}

          <Grid.Group
            verticalGutters={Grid.Group.VERTICAL_GUTTERS}
            horizontalGutters={Grid.Group.HALF_HORIZONTAL_GUTTERS}
          >
            <Grid.Column all="35" medium="35" small="100" tiny="100">
              <Button fullWidth secondary onClick={onCancel}>
                {CANCEL}
              </Button>
            </Grid.Column>
            <Grid.Column all="65" medium="65" small="100" tiny="100">
              <Form.Field>
                <ActionButton
                  fullWidth
                  primary
                  onClick={buttonAction}
                  type={Button.SUBMIT_TYPE}
                  isProcessing={isProcessing}
                  isDisabled={buttonDisabled}
                >
                  {buttonLabel}
                </ActionButton>
              </Form.Field>
            </Grid.Column>
          </Grid.Group>
        </Form>
      </Grid>
    )
  }
}

SetupMFAStep.propTypes = {
  title: string.isRequired,
  subtitle: string.isRequired,
  footnoteLabel: string.isRequired,
  footnoteUrl: string.isRequired,
  onCancel: func.isRequired,
  boxContent: node.isRequired,
  buttonLabel: string.isRequired,
  buttonAction: func.isRequired,
  onStartRegistration: func.isRequired,
  isProcessing: bool,
  buttonDisabled: bool,
  errorCode: string,
  children: node
}

export default SetupMFAStep
